import Big from 'big.js';
import { Packery } from 'packery';
import axios from 'smg/axios';
import * as buttons from 'smg/buttons';
import * as models from 'smg/customer-api/models';
import { ReportValidity } from 'smg/form';
import * as toast from 'smg/toast';
import { DollarFormat } from 'smg/util';
import * as carts from '../carts';

void main();

async function main() {
    // BUTTONS
    const chooseQtyBtn = document.querySelector('#qty-info-icon') as HTMLAnchorElement;
    const addToCartBtn = document.querySelector('#add-to-cart-btn') as HTMLButtonElement;

    // FRONT INPUTS
    const frontTop = document.querySelector('#front-top-message') as HTMLInputElement;
    const frontBottom = document.querySelector('#front-bottom-message') as HTMLInputElement;

    // BACK INPUTS
    const backTop = document.querySelector('#back-top-message') as HTMLInputElement;
    const backBottom = document.querySelector('#back-bottom-message') as HTMLInputElement;

    // QUANTITY/PRICE
    const qtyNumber = document.querySelector('#qty-number') as HTMLInputElement;
    const qtyPrice = document.querySelector('#qty-price') as HTMLElement;

    // GET STOCK ITEM
    const stockItemID = 'Ee46nGPAxjCH3QJCrBIABA';
    const stockItemsResp = await axios.get('/stock-items', {
        params: {
            'q': `id:${stockItemID}`,
        },
    });
    const stockItem = models.StockItemsHyejooResponse.fromJSON(stockItemsResp.data).stockItems[0];

    // INPUT EVENT LISTENERS
    frontTop.addEventListener('input', () => {
        const output = document.querySelector('#coin-front #top-text') as HTMLElement;
        output.textContent = frontTop.value;
    });
    frontTop.dispatchEvent(new Event('input'));

    frontBottom.addEventListener('input', () => {
        const output = document.querySelector('#coin-front #bottom-text') as HTMLElement;
        output.textContent = frontBottom.value;
    });
    frontBottom.dispatchEvent(new Event('input'));

    backTop.addEventListener('input', () => {
        const output = document.querySelector('#coin-back #top-text') as HTMLElement;
        output.textContent = backTop.value;
    });
    backTop.dispatchEvent(new Event('input'));

    backBottom.addEventListener('input', () => {
        const output = document.querySelector('#coin-back #bottom-text') as HTMLElement;
        output.textContent = backBottom.value;
    });
    backBottom.dispatchEvent(new Event('input'));

    // CALCULATE PRICE
    const calculatePrice = (selectedQty: number): Big => {
        interface quantityPrice {
            qty: number;
            price: Big;
        }
        const qtyPrices: quantityPrice[] = [];
        for (const [qtyKey, price] of stockItem.quantityPricing) {
            qtyPrices.push({
                qty: qtyKey,
                price,
            });
        }
        qtyPrices.sort((a, b) => b.qty - a.qty);
        let price = Big(0);
        for (const qp of qtyPrices) {
            if (selectedQty >= qp.qty) {
                price = qp.price;
                break;
            }
        }
        return price.mul(selectedQty || 0);
    };

    const quantityTiers = (): carts.QuantityTier[] =>
        [...stockItem.quantityPricing.entries()].map(([quantity, unitPrice]) => ({ quantity, unitPrice, fixedPrice: Big(0) }));

    // CHOOSE QUANTITY EVENT LISTENER
    let qty = 1;
    qtyNumber.value = String(qty);
    qtyPrice.textContent = DollarFormat(calculatePrice(qty));
    qtyNumber.addEventListener('input', () => {
        qty = parseInt(qtyNumber.value, 10);
        qtyPrice.textContent = DollarFormat(calculatePrice(qty));
    });
    chooseQtyBtn.addEventListener('click', async () => {
        await carts.PromptQuantityEdit(qty, quantityTiers()).
            then(res => {
                qty = res;
                qtyNumber.value = String(qty);
                qtyPrice.textContent = DollarFormat(calculatePrice(qty));
            });
    });

    // ADD TO CART EVENT LISTENER
    addToCartBtn.addEventListener('click', () => {
        if (qty < 1) {
            qtyNumber.setCustomValidity(' ');
            ReportValidity(qtyNumber);
            toast.Error('Please enter a valid quantity!');
            return;
        }
        buttons.Start(addToCartBtn);
        void carts.AddCartItem(
            {
                stockItemID: stockItemID,
                quantity: qty,
                customizations: {
                    '01. Front Top Text': frontTop.value,
                    '02. Front Bottom Text': frontBottom.value,
                    '03. Back Top Text': backTop.value,
                    '04. Back Bottom Text': backBottom.value,
                },
            },
        ).finally(() => buttons.Stop(addToCartBtn));
    });

    const coinContainer = document.querySelector('#coin-container') as HTMLElement;
    new Packery(coinContainer, {
        itemSelector: '.grid-item',
        gutter: 0,
        transitionDuration: 0,
    });
}
